module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mdc"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "y-modal-box",
    class: [{
      'y-modal-align-center': _vm.center
    }, _vm.type ? ("y-modal-" + _vm.type) : ''],
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return; }
        _vm.del($event)
      }
    }
  }, [_c('div', {
    staticClass: "y-modal",
    style: ({
      top: (_vm.top + "px")
    })
  }, [_c('div', {
    staticClass: "y-modal-content"
  }, [_c('div', {
    staticClass: "m-header"
  }, [_c('h2', [(_vm.type === 'confirm' || _vm.type === 'alert') ? _c('y-svg', {
    class: ("y-modal-" + _vm.icon),
    attrs: {
      "type": _vm.icon,
      "width": 26
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.$slots.title) ? [_vm._v(_vm._s(_vm.title))] : _vm._e(), _vm._v(" "), _vm._t("title")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "m-body"
  }, [(!_vm.$slots.center) ? _c('p', [_vm._v(_vm._s(_vm.content))]) : _vm._e(), _vm._v(" "), _vm._t("center")], 2), _vm._v(" "), _c('div', {
    staticClass: "m-footer"
  }, [(_vm.type !== 'alert') ? _c('y-button', {
    attrs: {
      "type": "ghost"
    },
    domProps: {
      "textContent": _vm._s(_vm.cancelText)
    },
    nativeOn: {
      "click": function($event) {
        _vm.next('reject')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('y-button', {
    attrs: {
      "type": "primary"
    },
    domProps: {
      "textContent": _vm._s(_vm.okText)
    },
    nativeOn: {
      "click": function($event) {
        _vm.next('resolve')
      }
    }
  })], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-34efc959!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/modal/modal.vue
// module id = 463
// module chunks = 27